import { render } from "./as-button.vue?vue&type=template&id=70aafdc8&scoped=true&ts=true"
import script from "./as-button.vue?vue&type=script&lang=ts"
export * from "./as-button.vue?vue&type=script&lang=ts"

import "./as-button.vue?vue&type=style&index=0&id=70aafdc8&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70aafdc8"]])

export default __exports__